import { gql } from '@apollo/client';

export const UPDATE_AVATAR = gql`
  mutation onUserAvatar($avatar: ID!, $user: ID!) {
    updateUsersPermissionsUser(id: $user, data: { avatar: $avatar }) {
      data {
        id
        attributes {
          avatar {
            data {
              id
              attributes {
                media {
                  data {
                    attributes {
                      url
                    }
                  }
                }
              }
            }
          }
        }
      }
    }
  }
`;

export default UPDATE_AVATAR;
